import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Bill, Biller } from "model/";
/**
* @class BillerGroup
* @classdesc Class definition for record type from model
* @param {Class} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.reminders[0];
* const reminder = new Reminder(record);
* @property {String} _id - The id of biller group.
* @property {String} _name - The name of biller group.
* @property {Boolean} _show - The show value of biller group.
*/
export default class BillerGroup extends BCMSRecord{
    _id;   
    _name;
    _show;

    constructor (record){
      super(record);      
    }

    /**
	* @static
	* @memberof BillerGroup
  * @param {Biller} Array - an instance of payments class 
	* @returns {Biller} Array
    * @description sorts an array of billers by name in ascending order.
  	* @example BillerGroup.sortNameAscending(billers);	
	*/
  static sortNameAscending(billers) {
    return billers.sort((a, b) => {
      const aName = a.name;
      const bName = b.name;
      if(aName > bName) { return 1;}
      else if(aName < bName) { return -1; }
      return 0;
  });
}
  /**
	* @static
	* @memberof BillerGroup
  * @param {billers} Array - an array of billers 
	* @returns {group} OBJECT
    * @description groups billers by group.
  	* @example BillerGroup.billerByGroup(billers);	
	*/
  static billerByGroup(billers) {
    const billerHasDueBills =(biller)=>{
      return Bill.initAll().filter(bill => {
        if( bill.biller.id === biller.id){
           if(bill.status.toLowerCase() === "due"){
                   if (bill.reminder){
                       return  bill.reminder.daysToRemindMeInAdvanced > bill.reminder.dueDate.diff()
                   }
                   return true
           }
          }

          
return false;
       }).length > 0;
      }
    return billers.reduce((groups,biller)=>{
     if(biller.addType === "" && !billerHasDueBills(biller)){
      if(biller.billerGroup){
        if(groups[biller.billerGroup.id]){
          groups[biller.billerGroup.id].push(biller)
        }else{
          groups[biller.billerGroup.id] = [];
          groups[biller.billerGroup.id].push(biller)
        }
      }else{
        if(groups["default"]){       
        groups["default"].push(biller)
        }else{         
          groups["default"] = [];
          groups["default"].push(biller)
          
        }
      }
     }
       
      return groups;
    },{})
  }
}
BillerGroup.define({
    "recordType":"billerGroups",
    "recordIDProp":"billerGroupID",
    "className" : "BillerGroup",
    "recordProperties":[
      /** 
     * @name id
     * @instance
     * @property get {String} - gets id of biller group
     * @property set {String} - sets the id of the biller group
     * @memberof BillerGroup 
     */
        BCMSRecordProperty.mapToString("id","_id","billerGroupID"),
      /** 
     * @name name
     * @instance
     * @property get {Biller} - gets name of biller group
     * @property set {Biller} - sets the name of the biller group
     * @memberof BillerGroup 
     */ 
        BCMSRecordProperty.mapToString("name","_name", "billerGroupName"),
    /** 
     * @name show
     * @instance
     * @property get {Boolean} - gets the show value of biller group
     * @property set {Boolean} - sets the show value of biller group
     * @memberof BillerGroup 
     */
        BCMSRecordProperty.mapToBoolean("show","_show","billerGroupShow"),     
    ]
})




